import { VENUES_CARD_VIDEO_SET_ACTIVE } from './actionNames/venuesCardVideoActionNames';

export const setVenueVideoActive = (activeVideo: string) => ({
  type: VENUES_CARD_VIDEO_SET_ACTIVE,
  payload: activeVideo,
});
